"use client";

import React from "react";
import { LocaleLink as Link } from "@/components/shared/LocaleLink";
import { useTranslations } from "@/lib/i18n-client";
import { Reveal, Stagger, StaggerItem } from "@/components/shared/motion";
import { Users, Wifi, Map, Heart, Star, ArrowRight } from "lucide-react";

/**
 * Photo Commerce — family pack promotional module. ONE ACCOUNT, WHOLE TRIP
 * framing per content-pillars.md P3 (family-commerce lane). Claim-safe
 * (no fabricated ratings).
 */
export default function FamilyPack() {
  const { t } = useTranslations();

  const benefits = [
    { icon: Users, t: t("pc.family.b1", "One account for everyone"), b: t("pc.family.b1b", "Buy one plan, share the connection with family.") },
    { icon: Wifi, t: t("pc.family.b2", "Hotspot enabled"), b: t("pc.family.b2b", "Turn your phone into a portable Wi-Fi hotspot.") },
    { icon: Map, t: t("pc.family.b3", "Works across devices"), b: t("pc.family.b3b", "Tablets, laptops, and phones — all connected.") },
    { icon: Heart, t: t("pc.family.b4", "Simple setup"), b: t("pc.family.b4b", "Install once, share with everyone in minutes.") },
  ];

  return (
    <section className="container mx-auto px-4 py-10">
      <Reveal as="div" className="pc-card p-8 sm:p-10 max-w-4xl mx-auto" y={22}>
        <div className="flex flex-col md:flex-row items-center gap-6">
          <div className="w-16 h-16 rounded-2xl bg-primary/10 text-primary flex items-center justify-center shrink-0">
            <Users className="w-8 h-8" />
          </div>
          <div className="flex-1 text-center md:text-left">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold px-3 py-1 mb-2">
              <Star className="w-3 h-3" /> {t("pc.family.badge", "For families & couples")}
            </span>
            <h2 className="text-2xl font-extrabold text-foreground">{t("pc.family.title", "One account, whole trip")}</h2>
            <p className="text-muted-foreground mt-1">{t("pc.family.sub", "Keep the whole family connected with a single eSIM — share data via hotspot, no separate plans needed.")}</p>
          </div>
          <Link href="/destinations/" className="flex items-center gap-2 rounded-full bg-primary text-primary-foreground font-bold px-7 h-12 shrink-0 hover:bg-primary/90 transition-all active:scale-[0.98] group/fam">
            {t("pc.family.cta", "Find family plans")} <ArrowRight className="w-4 h-4 transition-transform group-hover/fam:translate-x-0.5" />
          </Link>
        </div>
        <Stagger as="div" className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-4" staggerChildren={0.07} amount={0.3}>
          {benefits.map(({ icon: Icon, t: tt, b }) => (
            <StaggerItem as="div" key={tt} y={14} className="flex items-start gap-3">
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-primary/10 text-primary shrink-0"><Icon className="w-4 h-4" /></span>
              <div><div className="text-sm font-bold text-foreground">{tt}</div><div className="text-xs text-muted-foreground">{b}</div></div>
            </StaggerItem>
          ))}
        </Stagger>
      </Reveal>
    </section>
  );
}
